import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  pageSize: 20,
  mainpageSize: 6,
  maxFetchCount: 3,
  maxPageDisplay: 20,

  fetchId: null,
  isFetching: false,
  isFetched: false,
  fetchError: null,
  fetchCount: 0,
  totalCount: 0,
  items: [],
  defaultItems: {},

  filters: {
    txType: [],
    districts: [],
    txSource: [],
  },
  sorting: {
    field: 'tx_date',
    direction: 'desc',
  },
};

export default {
  namespaced: true,

  state,
  mutations,
  actions,
  getters,
};
